import dayjs from 'dayjs';

const STORAGE_PREFIX = 'robocon_form_draft_v1';

export const formatDraftTimestamp = (iso) => {
  if (!iso) return '';
  const d = dayjs(iso);
  return d.isValid() ? d.format('MMM D, YYYY h:mm A') : '';
};

const draftKey = (formKey, userId) => `${STORAGE_PREFIX}:${formKey}:${userId ?? 'anon'}`;

const serializeValue = (val) => {
  if (val == null) return val;
  if (typeof File !== 'undefined' && val instanceof File) return undefined;
  if (typeof Blob !== 'undefined' && val instanceof Blob) return undefined;
  if (dayjs.isDayjs(val)) return { __t: 'dayjs', v: val.isValid() ? val.toISOString() : null };
  if (val instanceof Date) return { __t: 'date', v: val.toISOString() };
  if (Array.isArray(val)) {
    const items = val.map(serializeValue).filter((x) => x !== undefined);
    return items;
  }
  if (typeof val === 'object') {
    const out = {};
    Object.entries(val).forEach(([k, v]) => {
      const s = serializeValue(v);
      if (s !== undefined) out[k] = s;
    });
    return out;
  }
  return val;
};

const reviveValue = (val) => {
  if (val == null) return val;
  if (typeof val === 'object' && val.__t === 'dayjs') {
    return val.v ? dayjs(val.v) : null;
  }
  if (typeof val === 'object' && val.__t === 'date') {
    return val.v ? new Date(val.v) : null;
  }
  if (Array.isArray(val)) return val.map(reviveValue);
  if (typeof val === 'object') {
    const out = {};
    Object.entries(val).forEach(([k, v]) => {
      out[k] = reviveValue(v);
    });
    return out;
  }
  return val;
};

export const serializeFormDraft = (data) => serializeValue(data);

export const reviveFormDraft = (data) => reviveValue(data);

export const loadFormDraft = (formKey, userId) => {
  if (!formKey || userId == null) return null;
  try {
    const raw = localStorage.getItem(draftKey(formKey, userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !parsed.data) return null;
    return {
      data: reviveFormDraft(parsed.data),
      savedAt: parsed.savedAt || null,
    };
  } catch {
    return null;
  }
};

export const saveFormDraft = (formKey, userId, data) => {
  if (!formKey || userId == null) return null;
  const savedAt = new Date().toISOString();
  try {
    localStorage.setItem(
      draftKey(formKey, userId),
      JSON.stringify({ savedAt, data: serializeFormDraft(data) }),
    );
    return savedAt;
  } catch {
    return null;
  }
};

export const clearFormDraft = (formKey, userId) => {
  if (!formKey || userId == null) return;
  try {
    localStorage.removeItem(draftKey(formKey, userId));
  } catch {
    /* ignore */
  }
};
